import {State} from '../types/state'

export const isEventMembershipOfferAvailable = (state: State, eventId: string): boolean =>
  state.membershipOffers.membershipOffers?.[eventId]
